@if (isAllowToShowTerm) {
  <main class="page-wrapper"
    role="main"
    [attr.aria-label]="'ACCESSIBILITY.DATA_PROCESS_TERMS' | translate"
    [ngStyle]="{backgroundImage: 'url(' + (backgroundImg$ | async).backgroundImage + ')'}">
    <article class="option-card" role="article">
      <section class="terms-content"
        role="region"
        [attr.aria-label]="'ACCESSIBILITY.LEGAL_CONTENT' | translate"
        [innerHTML]="'LEGAL.DATA-PROCESS-TERMS.BODY' | translate: {dataSecurityLink: dataSecurityLink}">
      </section>
      <footer class="option-card-footer" role="contentinfo">
        <div class="link-wrapper"
          role="group"
          [attr.aria-label]="'ACCESSIBILITY.TERMS_DECISION_BUTTONS' | translate">
          <button id="logout"
            type="button"
            class="btn btn-outline-dark"
            (click)="logout()"
            [attr.aria-label]="'ACCESSIBILITY.DECLINE_TERMS' | translate">
            {{'LEGAL.BUTTON.NO' | translate}}
          </button>
          <button id="accept_button"
            type="button"
            class="button dark-blue btn-size"
            (click)="acceptDataProcess()"
            [attr.aria-label]="'ACCESSIBILITY.ACCEPT_TERMS' | translate">
            {{ 'LEGAL.BUTTON.I-ACCEPT' | translate }}
            <i class="fal fa-check-circle" aria-hidden="true"></i>
          </button>
        </div>
      </footer>
      <div id="progress-bar"
        role="progressbar"
        aria-hidden="true"
        [attr.aria-label]="'GENERAL.LOADING' | translate">
        <div class="fill"></div>
      </div>
    </article>
  </main>
}
@if (!isAllowToShowTerm) {
  <main class="page-wrapper"
    role="main"
    [attr.aria-label]="'ACCESSIBILITY.DATA_PROCESS_TERMS_READONLY' | translate"
    [ngStyle]="{backgroundImage: 'url(' + (backgroundImg$ | async).backgroundImage + ')'}">
    <article class="option-card"
      role="article"
      [innerHTML]="'LEGAL.DATA-PROCESS-TERMS.BODY' | translate: {dataSecurityLink: dataSecurityLink}">
    </article>
  </main>
}
